import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const OPTS = [["saturday", "Sat"], ["sunday", "Sun"], ["both", "Both"]];

export function MatchDayPill({ league, isAdmin, onChanged }) {
  const [busy, setBusy] = useState(false);
  const cur = league.match_day || "both";
  const set = async (md) => {
    if (md === cur || busy) return;
    setBusy(true);
    try { await api.patch(`/leagues/${league.id}/match-day`, { match_day: md }); toast.success(`${league.name} · match day ${md === "both" ? "Sat & Sun" : md}`); onChanged?.(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (!isAdmin) return <span className="text-[9px] tracking-widest uppercase px-2 py-1 rounded border border-border opacity-70" data-testid={`league-matchday-${league.id}`}>Match day · {cur === "both" ? "Sat & Sun" : cur}</span>;
  return (
    <div className="inline-flex items-center gap-1" data-testid={`league-matchday-${league.id}`} title="Match day — drives which referees are eligible (Saturday / Sunday refs)">
      <span className="text-[9px] tracking-widest uppercase opacity-50 mr-1">Match day</span>
      <div className="inline-flex rounded border border-border overflow-hidden">
        {OPTS.map(([v, l]) => (
          <button key={v} type="button" onClick={() => set(v)} disabled={busy} data-testid={`league-matchday-${league.id}-${v}`}
            className={`text-[9px] tracking-widest uppercase px-2 py-1 ${cur === v ? "bg-[#83B68B] text-black font-bold" : "hover:bg-[#83B68B]/10"}`}>{l}</button>
        ))}
      </div>
      {!league.match_day && <span className="text-[9px] text-amber-400 ml-1" data-testid={`league-matchday-unset-${league.id}`}>not set · treated as both</span>}
    </div>
  );
}
